export const isPdf = (assetName) => {
  return assetName ? assetName.split(".").reverse()[0] === "pdf" : false;
};
